import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Customer } from 'app/models/customer.model';
import { Domain } from 'app/models/domain.model';
import { User } from 'app/models/user.model';
import { CustomerService } from 'app/services/customer/customer.service';
import { DomainsService } from 'app/services/domains/domains.service';
declare const swal: any;

@Component({
  selector: 'app-edit-domain',
  templateUrl: './edit-domain.component.html',
  styleUrls: ['./edit-domain.component.css']
})
export class EditDomainComponent implements OnInit {

  enterprise: User;
  customers: Customer[];
  customer: any;
  domain: Domain;
  // customers = [{
  //   name: 'Baxter'
  // }, {
  //   name: 'Unphu'
  // }];

  constructor( private formBuilder: FormBuilder,
    private domainService: DomainsService,
    private customerService: CustomerService,
    private dialogRef: MatDialogRef<EditDomainComponent>) { }

  ngOnInit(): void {
    this.enterprise = JSON.parse(sessionStorage.getItem('loggedUser'));
    this.customerService.getCustomers().subscribe(result => {
      this.customers = result;
    });
  }

  domainForm = this.formBuilder.group({
    customer: ['', Validators.required]
  });

  saveDomain(){
    try {
      this.customer = this.domainForm.value.customer;
      if(this.domainForm.status === 'INVALID'){
        this.openAlert(0);
      }else{
        this.domain = {
          customer: this.customer,
          enterprise: this.enterprise.databaseId
        };
        // console.log(this.domain);
        this.domainService.saveDomain(this.domain).subscribe(result => {
          this.openAlert(1);
          this.dialogRef.close(result);
        })
      }
    } catch (error) {
      console.error(error);
    }
  }

  cancel(){
    this.dialogRef.close();
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: '',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }
}
